<app-page-header [title]="'Body Type Details'" [subtitle]="'View details of the selected body type'"></app-page-header>
<div class="mb-5">
    <div class="flex gap-2 items-center mb-2">
        <img
                [src]="bodyType?.icon?.content?.preview?.cloudfrontUrl || 'assets/images/no-image.png'"
                alt="Brand Logo"
                class="w-12 h-12 object-cover rounded-sm">
        <h2 class="text-xl">{{ bodyType?.label }}</h2>
    </div>
    <p><strong>ID:</strong> {{ bodyType?.id }}</p>
    <p><strong>Label:</strong> {{ bodyType?.label }}</p>
    <p><strong>Created By</strong> {{ bodyType?.createdBy | roleName }}</p>
    <p><strong>Updated By</strong> {{ bodyType?.updatedBy | roleName }}</p>
</div>
<div class="flex justify-between gap-2">
    <div>
        <p-button (click)="openEditDialog()" icon="pi pi-pencil" isAdmin label="Edit" text></p-button>
        <p-button (click)="confirmDelete()" icon="pi pi-trash" isAdmin label="Delete" severity="danger" text></p-button>
    </div>
    <p-button label="Back to Body Types" icon="pi pi-arrow-left" routerLink="/body-types"></p-button>
</div>

<!-- Update Dialog -->
<app-update-body-type-dialog
        [(visible)]="displayUpdateDialog"
        [bodyType]="editableBodyType"
        (bodyTypeUpdated)="reloadBodyTypeDetails()"
></app-update-body-type-dialog>
